import $ from 'jquery';
import 'sharer.js';

const initSocialShare = () => {
    const targetUrl = window.location.href;

    $('.js-social-share').each(function() {
        $(this).attr('data-url', targetUrl);
    });
};

$(() => {
    initSocialShare();
});
